import {Pending} from '../../model/questionnaires/Pending';
import {INIT} from '@ngrx/store';
import {PatientActionTypes} from '../actions/patient.actions';

export interface State {
  pendings: Pending[] | null;
  errorMessage: string | null;
}

export const initialState: State = {
  pendings: null,
  errorMessage: null
};

export function patientReducer(state = initialState, action): State {
  switch (action.type) {
    case PatientActionTypes.GET_PENDINGS: {
      return {
        ...state,
        pendings: action.payload,
        errorMessage: null
      };
    }

    case PatientActionTypes.GET_PENDINGS_SUCCESS: {
      return {
        ...state,
        pendings: action.payload.pendings,
        errorMessage: null
      };
    }

    case PatientActionTypes.GET_PENDINGS_FAILURE: {
      return {
        ...state,
        pendings: null,
        errorMessage: '[Patient] Get pendings failed'
      };
    }

      case INIT: {
        const data = localStorage.getItem('pendings');
        if (data !== null) {
          return {
            ...state,
            pendings: JSON.parse(data),
            errorMessage: null
          };
        } else {
          return {
            ...state
          };
        }
      }

      default: {
        return state;
      }
    }

  }

